module.exports = __webpack_public_path__ + "assets/pdf/場地租用守則.pdf";